export default __webpack_public_path__ + "static/media/Head_3_Ear_3_C2.49516b2e.svg";